<div class="flex items-center">
  <app-avatar [src]="avatar()" [alt]="userName()" />
  <div class="ml-3 hidden sm:block">
    <p class="font-semibold text-sm">{{ userName() }}</p>
    <a href="#" class="text-xs text-amcom-purple hover:underline" (click)="onLogout($event)"> Sair </a>
  </div>
</div>
